import Icon from '../components/Icon.vue'

Icon.register({
  play: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M424.4 214.7c31.5 18.5 31.4 64.1 0 82.6l-352 208c-31.7 18.8-72.4-3.8-72.4-41.3v-416.1c0-41.8 43.8-58.2 72.4-41.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/play.js
// module id = 1645
// module chunks = 0